import {Text} from "@pg-design/text-module";

import {
    getPropertyCardDetailInfoTableRowLabel,
    PROPERTY_CARD_DETAIL_INFO_TABLE_CONTENT,
    PROPERTY_CARD_DETAIL_INFO_TABLE_ROW_KEYS,
    PropertyCardDetailInfoTableRowKey
} from "../../constants/property_card_detail_info_table_content";
import {
    IHomematchPropertyCardDetailInfoTableRow,
    useHomematchPropertyCardDetailInfoTableData
} from "../../hooks/use_homematch_property_card_detail_info_table_data";
import {IVariable} from "../../types/IVariable";
import {IPropertyDetailDTO} from "../../types/property/IPropertyDetailDTO";

import * as styles from "./HomematchPropertyCardDetailInfoTable.module.css";

interface IProps {
    property: IPropertyDetailDTO;
    quarterTypes?: IVariable[];
}

export const HomematchPropertyCardDetailInfoTable = (props: IProps) => {
    const {property, quarterTypes} = props;

    const data = useHomematchPropertyCardDetailInfoTableData(property, quarterTypes);

    return (
        <div className={styles.table}>
            {PROPERTY_CARD_DETAIL_INFO_TABLE_ROW_KEYS.map((rowKey) => (
                <HomematchPropertyCardDetailInfoTableRow key={rowKey} row={data[rowKey]} rowKey={rowKey} />
            ))}
        </div>
    );
};

interface ITableRowProps {
    row: IHomematchPropertyCardDetailInfoTableRow;
    rowKey: PropertyCardDetailInfoTableRowKey;
}

const HomematchPropertyCardDetailInfoTableRow = (props: ITableRowProps) => {
    const {row, rowKey} = props;

    return (
        <div className={styles.row}>
            <div className={styles.rowContent}>
                <div className={styles.iconHolder}>{row.icon}</div>

                <Text capitalize color="var(--colors-gray-700)" variant="info_txt_1">
                    {getPropertyCardDetailInfoTableRowLabel(rowKey)}
                </Text>
            </div>

            <div className={styles.valueHolder}>
                <Text align="right" capitalize strong variant="body_copy_2">
                    {hasInfoTableRowValue(row.value) ? (
                        row.value
                    ) : (
                        <>
                            <span className={styles.emptyValueLine}>{PROPERTY_CARD_DETAIL_INFO_TABLE_CONTENT.EMPTY_VALUE_LINES[0]}</span>
                            <br />
                            <span className={styles.emptyValueLine}>{PROPERTY_CARD_DETAIL_INFO_TABLE_CONTENT.EMPTY_VALUE_LINES[1]}</span>
                        </>
                    )}
                </Text>
            </div>
        </div>
    );
};

function hasInfoTableRowValue(value: number | string | undefined) {
    return value != null && value !== "";
}
import {Text} from "@pg-design/text-module";

import {
    getPropertyCardDetailInfoTableRowLabel,
    PROPERTY_CARD_DETAIL_INFO_TABLE_CONTENT,
    PROPERTY_CARD_DETAIL_INFO_TABLE_ROW_KEYS,
    PropertyCardDetailInfoTableRowKey
} from "../../constants/property_card_detail_info_table_content";
import {
    IHomematchPropertyCardDetailInfoTableRow,
    useHomematchPropertyCardDetailInfoTableData
} from "../../hooks/use_homematch_property_card_detail_info_table_data";
import {IVariable} from "../../types/IVariable";
import {IPropertyDetailDTO} from "../../types/property/IPropertyDetailDTO";

import * as styles from "./HomematchPropertyCardDetailInfoTable.module.css";

interface IProps {
    property: IPropertyDetailDTO;
    quarterTypes?: IVariable[];
}

export const HomematchPropertyCardDetailInfoTable = (props: IProps) => {
    const {property, quarterTypes} = props;

    const data = useHomematchPropertyCardDetailInfoTableData(property, quarterTypes);

    return (
        <div className={styles.table}>
            {PROPERTY_CARD_DETAIL_INFO_TABLE_ROW_KEYS.map((rowKey) => (
                <HomematchPropertyCardDetailInfoTableRow key={rowKey} row={data[rowKey]} rowKey={rowKey} />
            ))}
        </div>
    );
};

interface ITableRowProps {
    row: IHomematchPropertyCardDetailInfoTableRow;
    rowKey: PropertyCardDetailInfoTableRowKey;
}

const HomematchPropertyCardDetailInfoTableRow = (props: ITableRowProps) => {
    const {row, rowKey} = props;

    return (
        <div className={styles.row}>
            <div className={styles.rowContent}>
                <div className={styles.iconHolder}>{row.icon}</div>

                <Text capitalize color="var(--colors-gray-700)" variant="info_txt_1">
                    {getPropertyCardDetailInfoTableRowLabel(rowKey)}
                </Text>
            </div>

            <div className={styles.valueHolder}>
                <Text align="right" capitalize strong variant="body_copy_2">
                    {hasInfoTableRowValue(row.value) ? (
                        row.value
                    ) : (
                        <>
                            <span className={styles.emptyValueLine}>{PROPERTY_CARD_DETAIL_INFO_TABLE_CONTENT.EMPTY_VALUE_LINES[0]}</span>
                            <br />
                            <span className={styles.emptyValueLine}>{PROPERTY_CARD_DETAIL_INFO_TABLE_CONTENT.EMPTY_VALUE_LINES[1]}</span>
                        </>
                    )}
                </Text>
            </div>
        </div>
    );
};

function hasInfoTableRowValue(value: number | string | undefined) {
    return value != null && value !== "";
}
